import React from "react";
import { Link } from "react-router-dom";
import EssenceActionsDropdown from "../../Essence/EssenceActionsDropdown";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
import Fav from "../../Misc/Fav";
import Nl2Br from "../../Misc/Nl2Br";
import PriorityIcon from "../../Misc/PriorityIcon";
import { getTypedocByKey } from "./typedoc";
export default function WorkdocListItem(props) {
  let values = [];
  for (let field in props) values.push(field);

  const typeDocument = getTypedocByKey(props.classcode);
  const date = props.created ? new Date(props.created) : {};

  const onClick = (e) => {
    if (props.onItemClick) {
      props.onItemClick(e, props.listItemId);
    }
  };

  let selectedItems = Array.isArray(props.selectedItems)
    ? props.selectedItems
    : [];

  let itemClasses = "row pl-2 py-4  border-bottom list-item";
  itemClasses += props.highlightItem === String(props.id) ? " current" : "";
  itemClasses += selectedItems.includes(props.id) ? " active" : "";

  return (
    <>
      <div className={itemClasses}>
        <div
          style={{ wordBreak: "break-word" }}
          className="col-lg-10 m-lg-0 my-3"
        >
          <Link
            onClick={onClick}
            to={`/workdoc/${props.listMode}/${props.structureId}/${props.id}/${document.location.search}`}
          >
            <div className="mb-2  text-dark">
              <span
                className={`svg-icon mr-2 opacity-50 svg-icon-${typeDocument.iconColor}`}
              >
                {typeDocument.icon}
              </span>
              <PriorityIcon {...props} className="mr-1" />
              {props.label}

              <Fav className="ml-1" itemId={props.id} item={props} />
            </div>
            {props.classcode !== "template" && (
              <>
                <div className="text-dark-75 small">
                  {date.toLocaleString()}
                </div>
                <div className="text-dark-75 small">{props.areaname}</div>
                {props.description && (
                  <div className="text-dark-50 small">
                    <Nl2Br>{props.description}</Nl2Br>
                  </div>
                )}
              </>
            )}
          </Link>
        </div>

        <div className="col-lg-2  d-flex align-items-center justify-content-end text-right">
          <EssenceStateLabel
            stateCode={props.statetypecode}
            stateLabel={props.statelabel}
            essence="document"
            id={props.id}
          />
          <EssenceActionsDropdown
            essence={"document"}
            key={props.id}
            id={props.id}
            attendantItems={props.selectedItems}
            onPending={props.onPending}
            onDrop={props.onDrop}
          />
        </div>
      </div>
    </>
  );
}
